import React from 'react'
import ReactMarkdown from "react-markdown"
import { Slide, ContentContainer } from '../components/slide'
import { ImageCell, ImageGrid } from './images'
import Img from 'gatsby-image/withIEPolyfill'

export const Frontline = ( props ) => {
   return (
		<Slide theme="frontline" layout='split'>
			<ContentContainer transition='fadeUp'>
            <h2>
               <ReactMarkdown>{props.name}</ReactMarkdown>
            </h2>
            <h6>
               <ReactMarkdown>{props.title}</ReactMarkdown>
            </h6>
            <TriBar />
            <div className="frontline-text">
               <ReactMarkdown>{props.text}</ReactMarkdown>
            </div>
			</ContentContainer>
         <ImageGrid threshold={0.5}>
            <ImageCell
               transition="right"
               src={props.image}
               objectPosition={props.objPos}
            />
         </ImageGrid>
		</Slide>
   )
}

export const FrontlineContainer = (props) => {
   const slides = props.team.map( ( {id, name, title, text, image, objPos}) => {
      return (
         <Frontline
            key={id}
            name={name}
            title={title}
            text={text}
            image={image}
            objPos={objPos}
         />
      )
   })

   const gallery = props.team.map( ( {id, image, objPos} ) => {
      return (
         <FrontlineImg
            key={id}
            image={image}
            objPos={objPos}
         />
      )
   })

   return (
      <div className="frontline-container">

            <FrontlineSlides>
               {slides}
            </FrontlineSlides>
            {/* <FrontlineImageBox>
               {gallery}
            </FrontlineImageBox> */}

      </div>
   )
}

export const FrontlineSlides = (props) => {
   return (
      <div className="frontline-slides">
         {props.children}
      </div>
   )
}

export const FrontlineImageBox = (props) => {
   return (
      <div className="frontline-imageBox">
         {props.children}
      </div>
   )
}

export const FrontlineImg = (props) => {
   return (
      <div className="frontline-gallery-img">
         <Img
            fluid={props.image}
            loading="eager"
            objectFit='cover'
            objectPosition={props.objPos ? props.objPos : 'center center'}
         />
      </div>
   )
}


export const TriBar = ( props ) => {
   return (
		<div className="triBar">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 349 5"
			>
				<g id="seperator" transform="translate(0 0.5)">
					<line
						x2="344"
						transform="translate(5 4)"
						fill="none"
						stroke="#00ffff"
						strokeWidth="1"
					/>
					<line
						x2="344"
						fill="none"
						stroke="#ff0000"
						strokeWidth="1"
					/>
					<line
						x2="344"
						transform="translate(2 2)"
						fill="none"
						stroke="#404040"
						strokeWidth="1"
					/>
				</g>
			</svg>
		</div>
   )
}